import React from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import Login from "../Component/Login";
import Home from "../Component/Home";
import ResetPassword from "../Component/Resetpassword";
import RegisterUser from "../Component/Skinola/registerUser";
import NoPageFound from "../Component/NoPageFound";
import ConferenceList from "../Pages/Confarance/ConferenceList";
import CreateUser from "../Pages/User/CreateUser";
import GetInTouch from "../Pages/GetInTouch/GetInTouch";
import MetadataForm from "../Pages/WebInfo/MetadataForm";
import UserList from "../Pages/User/UserList";
import LocationList from "../Pages/Location/LocationList";
import AmenityList from "../Pages/Amenity/AmenityList";
import CreateAmenity from "../Pages/Amenity/CreateAmenity";
import CreateLocation from "../Pages/Location/CreateLocation";
import UpdateUser from "../Pages/User/UpdateUser";
import UpdateLocationForm from "../Pages/Location/UpdateLocationForm";
import UpdateAmenity from "../Pages/Amenity/UpdateAmenity";
import UserProfile from "../Component/UserProfile";
import AbstractList from "../Component/Skinola/AbstractLiast";
import ProtectedRoute from "./ProtectedRoute";
import RegistrationFeeStructure from "../Component/Skinola/spotregistration";

// ── FEEDBACK ROUTES ──
import FeedbackList from "../Pages/Feedback/FeedbackList";
import CreateFeedback from "../Pages/Feedback/CreateFeedback";

// ── WEBSITE CONTENT MANAGER ──
import WebsiteContentManager from "../Pages/WebInfo/WebsiteContentManager";

// ── MANAGE SCHEDULE (replaces UploadScheduleForm + ScheduleUsers) ──
import ManageSchedule from "../Component/Skinola/Manageschedule";
import ManageBrochure from "../Component/Skinola/Managebrochure";

// ── MANAGE BROCHURE ──
import ScheduleUsers from "../Component/ScheduleUsers";
import ConferenceForm from "../Pages/Confarance/ConferenceForm";
import ScientificProgramAdmin from "../Pages/ScirntificProgram/Scientificprogramadmin";
import ConferenceAdmin from "../Pages/ScirntificProgram/Conferenceadmin";
import WorkshopAdmin from "../Pages/ScirntificProgram/WorkshopAdmin";
import SpeakersAdmin from "../Pages/Speakersadmin/Speakersadmin";
import AbstractPage from "../Pages/Abstract/AbstractPage";


const RouterMain = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route exact path="/" element={<Login />} />
        <Route exact path="/registeruser" element={<RegisterUser />} />
        <Route exact path="/Restpassword" element={<ResetPassword />} />

        {/* Protected Routes */}
        <Route exact path="/Home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
        <Route path="/event" element={<ProtectedRoute><ConferenceList /></ProtectedRoute>} />
        <Route path="/speaker" element={<ProtectedRoute><SpeakersAdmin /></ProtectedRoute>} />
        <Route path="/Users" element={<ProtectedRoute><UserList /></ProtectedRoute>} />
        <Route path="/faculty" element={<ProtectedRoute><UserList /></ProtectedRoute>} />
        <Route path="/CreateFaculty" element={<ProtectedRoute><CreateUser /></ProtectedRoute>} />
        <Route path="/WebInfo" element={<ProtectedRoute><MetadataForm /></ProtectedRoute>} />
        
        {/* ✅ Create Conference — id नाही → Create mode */}
        <Route path="/conference/create"
          element={<ProtectedRoute><ConferenceForm /></ProtectedRoute>}
        />

        {/* ✅ Update Conference — id आहे → Edit mode */}
        <Route path="/conference/edit/:id"
          element={<ProtectedRoute><ConferenceForm /></ProtectedRoute>}
        />
        <Route path="/Scientific-Program"
          element={<ProtectedRoute><ScientificProgramAdmin /></ProtectedRoute>}
        />
        <Route path="/Workshop"
          element={<ProtectedRoute><WorkshopAdmin /></ProtectedRoute>}
        />
        <Route path="/Conference"
          element={<ProtectedRoute><ConferenceAdmin /></ProtectedRoute>}
        />
        <Route path="/Location" element={<ProtectedRoute><LocationList /></ProtectedRoute>} />
        <Route path="/CreateLocation" element={<ProtectedRoute><CreateLocation /></ProtectedRoute>} />
        <Route path="/Amenity" element={<ProtectedRoute><AmenityList /></ProtectedRoute>} />
        <Route path="/CreateAmenities" element={<ProtectedRoute><CreateAmenity /></ProtectedRoute>} />
        <Route path="/user/edit/:id" element={<ProtectedRoute><UpdateUser /></ProtectedRoute>} />
        <Route path="/location/edit/:id" element={<ProtectedRoute><UpdateLocationForm /></ProtectedRoute>} />
        <Route path="/amenity/edit/:id" element={<ProtectedRoute><UpdateAmenity /></ProtectedRoute>} />
        <Route path="/herosection" element={<ProtectedRoute><MetadataForm /></ProtectedRoute>} />
        <Route path="/welcome-message" element={<ProtectedRoute><MetadataForm /></ProtectedRoute>} />
        <Route path="/Abstract-message" element={<ProtectedRoute><AbstractPage/></ProtectedRoute>} />
        <Route path="/Userprofile" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
        <Route path="/Abstractlist" element={<ProtectedRoute><AbstractList /></ProtectedRoute>} />
        <Route path="/GetInTouch" element={<ProtectedRoute><GetInTouch /></ProtectedRoute>} />
        <Route path="/spotregistration" element={<ProtectedRoute><RegistrationFeeStructure /></ProtectedRoute>} />

        {/* ── MANAGE SCHEDULE ── */}
        <Route path="/manage-schedule" element={<ProtectedRoute><ManageSchedule /></ProtectedRoute>} />

        {/* ── MANAGE BROCHURE ── */}
        <Route path="/manage-brochure" element={<ProtectedRoute><ManageBrochure /></ProtectedRoute>} />

        {/* ── FEEDBACK MANAGEMENT ── */}
        <Route path="/feedback" element={<ProtectedRoute><FeedbackList /></ProtectedRoute>} />
        <Route path="/feedback/create" element={<ProtectedRoute><CreateFeedback /></ProtectedRoute>} />

        {/* ── WEBSITE CONTENT MANAGER ── */}
        <Route path="/website-content" element={<ProtectedRoute><WebsiteContentManager /></ProtectedRoute>} />

        {/* Fallback */}
        <Route path="*" element={<NoPageFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default RouterMain;